import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';

import { useGetBusinessUnitsQuery } from '@xemplo/business-unit-query';
import { FUTURE_SCHEDULED_PAYRUN } from '@xemplo/gp-constants';
import { useGetPayrunByIdQuery } from '@xemplo/payrun-query';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export const BusinessUnit = () => {
  const { getValues, setValue } = useFormContext<FormFields>();
  const payrun = getValues('payrun');

  const payrunId = useMemo(
    () => (!payrun || payrun === FUTURE_SCHEDULED_PAYRUN ? null : payrun),
    [payrun],
  );

  const payrunQuery = useGetPayrunByIdQuery({ id: payrunId });
  const buQuery = useGetBusinessUnitsQuery({ requestParams: { per_page: 0 } });

  const buData = useMemo(
    () =>
      buQuery.data?.result.rows.map((item) => ({
        key: item.id,
        value: item.name ?? item.id,
      })) ?? [],
    [buQuery.data?.result.rows],
  );

  const buList = useListBuilder(buData);

  const buId = useMemo(
    () => payrunQuery.data?.result.businessUnitId,
    [payrunQuery.data?.result.businessUnitId],
  );

  useEffect(() => {
    // Avoid using useEffect for setting default values
    // In this case, the field may be hidden and just setting the defaultSelectedKeys
    // won't work. Getting the multi to work just with defaultSelectedKeys causes
    // a lot of re-rendering and performance issues.
    if (buId) {
      setValue('businessUnit', buId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.FormLabel className={classNames({ hidden: buId != null })}>
      Business Unit
      <V2.TextDropdownRhf
        items={buList}
        name="businessUnit"
        placeholder="Select business unit"
        aria-label="Business unit field"
        data-testid="businessUnit"
        searchable
        rules={{ required: 'This field is required' }}
      />
    </S.FormLabel>
  );
};
